        $(document).ready(function () {
            $('.slider').slick({
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4000,
                arrows: true,
                adaptiveHeight: true,
            });
            $('.faq-question').on('click', function () {
                const $item = $(this).closest('.faq-item');
                const $answer = $item.find('.faq-answer');

                if ($item.hasClass('active')) {
                    $item.removeClass('active');
                    $answer.css('max-height', '0');
                } else {
                 
                    $('.faq-item.active').removeClass('active');
                    $('.faq-answer').css('max-height', '0');

                
                    $item.addClass('active');
                    $answer.css('max-height', $answer[0].scrollHeight + 'px');
                }
            });
        });